export const MODULE_PATH = "people";

export const PEOPLE = `/s/${MODULE_PATH}/`;
export const PEOPLE_LIST = `/s/${MODULE_PATH}/employees`;
export const PEOPLE_DETAIL = `/s/${MODULE_PATH}/employees/detail`;
export const EMPLOYEE_FORM = `/s/${MODULE_PATH}/employees/form`;
export const SUPPORT_FORM = `/s/${MODULE_PATH}/employees/support/form`;

export const USERS_LIST = `/s/${MODULE_PATH}/users`;
export const USERS_CUSTOMERS = `/s/${MODULE_PATH}/users/customers`;
export const USERS_LEADS = `/s/${MODULE_PATH}/users/leads`;

export const USER_LEAD_DETAIL = `/s/${MODULE_PATH}/users/leads/detail`;
export const USER_CUSTOMER_DETAIL = `/s/${MODULE_PATH}/users/customers/detail`;

export const USER_FORM = `/s/${MODULE_PATH}/users/user/form`;
export const USER_DETAIL = `/s/${MODULE_PATH}/users/detail`;

export const CODE_LIST = `/s/${MODULE_PATH}/codes`;
export const CODE_DETAIL = `/s/${MODULE_PATH}/codes/detail`;
export const CODE_FORM = `/s/${MODULE_PATH}/codes/form`;

export const DNR = `/s/${MODULE_PATH}/dnr`;

export const COMMUNICATIONS = `/s/${MODULE_PATH}/communications`;
export const COMMUNICATION_FORM = `/s/${MODULE_PATH}/communications/communication/form`;

export const ORGANIZATIONS_LIST = `/s/${MODULE_PATH}/companies`;
export const ORGANIZATION_FORM = `/s/${MODULE_PATH}/companies/form`;
export const ORGANIZATION_DETAIL = `/s/${MODULE_PATH}/companies/detail`;
